export default {
  extraFontSizeSmall: '12px',
  extraFontSizeMedium: '12px',
  extraFontSizeLarge: '14px',
  titleFontSizeSmall: '14px',
  titleFontSizeMedium: '16px',
  titleFontSizeLarge: '16px',
  closeSize: '20px',
  closeIconSize: '16px',
  headerHeightSmall: '44px',
  headerHeightMedium: '44px',
  headerHeightLarge: '50px'
}
